<template>
    <article class="thank-you-page">
        <!-- <AppHeader/> -->
        <FormHeader/>
        <ShowStep :current="3"/>
        <div class="section-bg">
            <div class="header-title mt-8">
                <h1>
                    認定登録申し込み完了
                </h1>
            </div>
        </div>
        <SectionLabel>お申し込みありがとうございました。</SectionLabel>
        <div class="cocothink-heading px-5 md:px-0">
            <img src="/images/cocothink.png" alt="" width="33" height="39">
            <p>ココシンクの登録はお済ですか？</p>
        </div>
        <div class="cocothink-guide px-5 md:px-0">
            <img src="/images/pc_cocothink_guide.png" alt="ココシンク 3つの特徴：1. 動画視聴機能 2. イベント参加機能 3. 更新までの資格管理" class="hidden md:block">
            <img src="/images/sp_cocothink_guide.png" alt="ココシンク 3つの特徴：1. 動画視聴機能 2. イベント参加機能 3. 更新までの資格管理" class="block md:hidden">
        </div>
        <div class="cocothink-cta px-5 md:px-0">
            <a :href="cocothinkRegisterUrl" target="_blank" rel="noopener noreferrer" class="cta-link">
                <img src="/images/fukidashi.png" alt="登録後、すぐに使える！" class="fukidashi w-full max-w-[320px] md:max-w-[380px]">
                <img src="/images/to_cocothink_button.png" alt="ココシンク登録" class="register-button w-full max-w-[280px] md:max-w-[400px]">
            </a>
        </div>
        <div class="contact-info">
            <ul>
                <li>
                    <h6>お問い合わせ</h6>
                    <p>support@jtca2020.or.jp</p>
                </li>
            </ul>
            <p>
                受付時間／10:00〜17:00（土曜・日曜・祝日を除く）
            </p>
        </div>
    </article>
</template>

<script>
import AppHeader from "../../parts/app/AppHeader";
import RightBanner from "../../parts/app/RightBanner";
import SectionLabel from "../../parts/app/SectionLabel";
import ShowStep from "../../parts/app/ShowStep";
import FormHeader from "../../parts/app/FormHeader";
import { clearFormData } from "../../utils/formDataCookie";
export default {
    name: "ThankYou",
    components: { AppHeader, RightBanner, ShowStep, SectionLabel, FormHeader },
    computed: {
        cocothinkRegisterUrl() {
            return process.env.MIX_COCOTHINK_REGISTER_URL;
        }
    },
    mounted() {
        // 決済完了後、Cookieに保存されたフォームデータをクリア
        clearFormData();
    }
}
</script>

<style scoped>
.cocothink-heading {
    @apply flex flex-col items-center justify-center gap-2 mt-10;
}

.cocothink-heading img {
    width: 33px;
    height: 39px;
}

.cocothink-heading p {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.08em;
    color: #35C5BB;
}

.cocothink-guide {
    @apply max-w-full mx-auto mt-6;
    width: 800px;
}

.cocothink-guide img {
    @apply w-full rounded-2xl;
}

.cocothink-cta {
    @apply flex flex-col items-center mt-6;
}

.cocothink-cta .cta-link {
    @apply flex flex-col items-center w-full;
    max-width: 400px;
}

.cocothink-cta .fukidashi {
    @apply relative;
    z-index: 1;
}

.cocothink-cta .register-button {
    @apply -mt-7 md:-mt-[33px];
}

.contact-info {
    @apply max-w-full mx-auto mt-8 p-8;
    width: 800px;
    background-color: #f2f8fb;
}

.contact-info ul {
    @apply flex flex-col lg:flex-row justify-center;
}

.contact-info ul li {
    @apply lg:text-center flex-1 relative;
}

.contact-info ul li:not(:first-of-type) {
    @apply mt-4 lg:mt-0;
}

.contact-info ul li:not(:last-of-type):after {
    @apply absolute h-full top-0 bottom-0 right-0 hidden lg:block;
    content: "";
    background-color: #dfe8ec;
    width: 1px;
}

.contact-info ul li h6 {
    font-size: 16px;
    letter-spacing: 0.12em;
}

.contact-info ul li p {
    @apply mt-2;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.12em;
    color: #006098;
}

.contact-info > p {
    @apply mt-8 lg:text-center;
    font-size: 14px;
    letter-spacing: 0.1em;
}
</style>
